import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';

import * as preferenceService from '@bingads-webui-component-legacy/preference/service/index';
import sessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import * as preferenceStoreFactory from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getAssignmentPageStyles } from '../style';

// eslint-disable-next-line
import { HotelCenterAssignment as HotelCenterAssignmentPromise } from '@bingads-webui-campaign-legacy/hotel-center-assignment/assignment-ui-next';

class HotelCenterAssignmentNew extends React.PureComponent {
  componentDidMount() {
    HotelCenterAssignmentPromise.bind(this).then((HotelCenterAssignment) => {
      this.view = new HotelCenterAssignment({
        isUINext: true,
        router: {
          navigateToSetup: () => {
            if (this.props && this.props.history) {
              this.props.history.push({
                pathname: '/campaign/vnext/hotelcenter/setup',
                search: this.props.history.location.search,
              });
            }
          },
        },
        perfMarker: this.props.perfMarker,
        preferenceService,
        sessionStore,
        preferenceStoreFactory,
      });
      this.view.render();
      $('#hotel-center-assignment').append(this.view.$el);
    });
  }
  render() {
    return (
      <div id="hotel-center-assignment" className={`${this.props.classes.assignment} assignment-container`} />
    );
  }
}

HotelCenterAssignmentNew.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
};

export const StyledAssignmentPage = withDefaultStyles(HotelCenterAssignmentNew, getAssignmentPageStyles);
